// Responsive popup configurations
export const responsivePopup = {
    medium: {
        display: 'anchored',
        width: 400,
        fullScreen: false,
        touchUi: false
    },
    large: {
        display: 'center',
        maxHeight: '80vh',
        maxWidth: 800,
        fullScreen: true,
        touchUi: true
    }
};

export const colorPopup = {
    medium: {
        display: 'anchored',
        touchUi: false,
        buttons: []
    }
};

// Datepicker controls configuration
export const getDatepickerControls = (isAllDay) => isAllDay ? ['date'] : ['datetime'];

// Responsive options for datepicker
export const getResponsiveOptions = (isAllDay) => isAllDay ? {
    medium: {
        controls: ['calendar'],
        touchUi: false
    }
} : {
    medium: {
        controls: ['calendar', 'time'],
        touchUi: false
    }
};

// Popup button configurations
export const getPopupButtons = (isEdit, onSave, onCancel) => {
    if (isEdit) {
        return [
            {
                text: 'Cancel',
                handler: onCancel,
                cssClass: 'mbsc-popup-button-secondary'
            },
            {
                text: 'Save',
                handler: onSave,
                keyCode: 'enter',
                cssClass: 'mbsc-popup-button-primary'
            }
        ];
    } else {
        return [
            {
                text: 'Add',
                handler: onSave,
                keyCode: 'enter',
                cssClass: 'mbsc-popup-button-primary'
            }
        ];
    }
};

// Color picker button configuration
export const getColorPickerButtons = (onSet, tempColor) => [
    'cancel',
    {
        text: 'Set',
        keyCode: 'enter',
        handler: onSet,
        cssClass: 'mbsc-popup-button-primary'
    }
];

// Hover popup configuration
export const hoverPopupConfig = {
    display: "anchored",
    touchUi: false,
    showOverlay: false,
    contentPadding: false,
    closeOnOverlayClick: false,
    width: 300
};

// Holiday popup configuration
export const holidayPopupConfig = {
    display: "anchored",
    touchUi: false,
    showOverlay: false,
    contentPadding: false,
    closeOnOverlayClick: false,
    width: "auto",
    position: "auto",
    anchor: "auto",
    closeOnEsc: true,
    showArrow: true,
    showCloseButton: false
};
